import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export enum DeviceEnum {
    mobile = "mobile",
    tablet = "tablet",
    desktop = "desktop"
}

export interface EnvironmentSliceStateInterface {
    isUploading: boolean;
    anonListConfig: { key: string; value: string }[];
    listConfig: { key: string; value: string }[];
    webListConfig: { key: string; value: string }[];
    liveListConfig: { key: string; value: string }[];
    serverTime: { datetime_now: number; timezone: string } | null;
    device: DeviceEnum;
}

const userAgent = navigator.userAgent;
const EnvironmentSliceState: EnvironmentSliceStateInterface = {
    isUploading: false,
    anonListConfig: [],
    listConfig: [],
    webListConfig: [],
    liveListConfig: [],
    serverTime: null,
    device: /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)
        ? DeviceEnum.tablet
        : /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)
          ? DeviceEnum.mobile
          : DeviceEnum.desktop
};

export const environmentSlice = createSlice({
    name: "environment",
    initialState: EnvironmentSliceState,
    reducers: {
        setIsUpload: (state, action: PayloadAction<boolean>) => {
            state.isUploading = action.payload;
        },
        setAnonListConfig: (state, action: PayloadAction<{ key: string; value: string }[]>) => {
            state.anonListConfig = action.payload;
        },
        setListConfig: (state, action: PayloadAction<{ key: string; value: string }[]>) => {
            state.listConfig = action.payload;
        },
        setWebListConfig: (state, action: PayloadAction<{ key: string; value: string }[]>) => {
            state.webListConfig = action.payload;
        },
        setLiveListConfig: (state, action: PayloadAction<{ key: string; value: string }[]>) => {
            state.liveListConfig = action.payload;
        },
        setServerTime: (state, action: PayloadAction<{ datetime_now: number; timezone: string }>) => {
            state.serverTime = action.payload;
        }
    }
});

export const { setIsUpload, setAnonListConfig, setListConfig, setWebListConfig, setLiveListConfig, setServerTime } = environmentSlice.actions;
export const selectEnvironment = (state: RootState) => state.environment;
export default environmentSlice.reducer;
